module.exports = __webpack_public_path__ + "img/banner_privacy_policy.923a5409.webp";